var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"required":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }